<template>
<v-card flat>
    <v-card-title>
      <div>
        <h3 class="subheading">Update Response name</h3>
        <div class="caption grey--text">Current name: {{ctext}}</div>
      </div>
      <v-spacer></v-spacer> 
                <v-btn icon @click="cancelTemplate"><v-icon>clear</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-container grid-list-xl>
          <v-layout class="mt-0" row wrap>                       
            <v-flex class="mt-0" xs12>
              <v-textarea
                auto-grow
                v-model="text"
                label="Response name"                
                placeholder="Write new response name here"
                rows="1"
              ></v-textarea>                                                     
            </v-flex>                        
            </v-layout>                  
        </v-container>
        <v-card-actions class="ma-0">
            <v-spacer></v-spacer> 
                <v-btn round flat color="primary" @click="cancelTemplate">Cancel</v-btn>
                <v-btn round flat color="primary" @click="updateTemplate">Update</v-btn>                
        </v-card-actions>  
        </v-card>
</template>

<script>
export default {
  data(){
    return{
      text:null
    }
  },
  methods:{
    updateTemplate(){
      let message = this.text
      this.$store.dispatch('aupdateResponse', message)
      this.text = null
      let status = false
      this.$store.dispatch('aresponsemenuStatusChange',status)
    },
    cancelTemplate(){
      let status = false
      this.$store.dispatch('aresponsemenuStatusChange',status)
    }
  },
  computed:{
    ctext(){
      let index = this.$store.state.currentResponseIndex
      let m = this.$store.state.responses[index].name
      console.log(m)
      return m   
    }
  }
}
</script>
